import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Notification } from '@portals/api';
import { AnimationOptions } from 'ngx-lottie';
import { fadeIn, fadeIn1, fadeOut } from '@portals/utils';

@Component({
	selector: 'web-response-actions',
	templateUrl: './response-actions.component.html',
	styleUrls: ['./response-actions.component.scss'],
	animations: [fadeIn, fadeIn1, fadeOut],
})
export class ResponseActionsComponent {
	@Input() typeReady: boolean = false;
	@Input() typingMode: boolean = false;
	@Input() isRecording: boolean = false;
	@Input() isMobile: boolean = false;
	@Input() audioMode: boolean = false;
	@Input() startAnimation: boolean = false;
	@Input() options: AnimationOptions = {};
	@Output() startResponse: EventEmitter<any> = new EventEmitter<any>();
	@Output() stopResponse: EventEmitter<any> = new EventEmitter<any>();
	@Output() switchCameraView: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}
}
